import { Link } from 'react-router-dom'
import {ArrowRight, Calendar, Clock} from 'lucide-react'
import Layout from '@/components/Layout'
import Container from '@/components/ui/Container'
import PageHero from '@/components/PageHero'
import NewsletterForm from '@/components/NewsletterForm'
import { blogPosts } from '@/data/blogPosts'

function formatDate(dateStr: string) {
  return new Date(dateStr).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })
}

function Blog() {
  const [featured, ...rest] = blogPosts

  return (
    <Layout>
      <PageHero
        eyebrow="Notícias e Blog"
        title="Insights sobre segurança eletrônica e conectividade"
        description="Acompanhe tendências, normas técnicas e conteúdos exclusivos produzidos pelos nossos especialistas."
      />

      <section className="py-20 sm:py-24">
        <Container>
          {featured ? (
            <Link
              to={`/blog/${featured.slug}`}
              className="group grid grid-cols-1 gap-8 overflow-hidden rounded-2xl border border-slate-100 shadow-sm transition-shadow hover:shadow-lg lg:grid-cols-2"
            >
              <div className="aspect-[16/10] overflow-hidden lg:aspect-auto">
                <img
                  src={featured.image}
                  alt={featured.title}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col justify-center p-7 sm:p-10">
                <span className="text-xs font-semibold uppercase tracking-widest text-cyan-600">{featured.category}</span>
                <h2 className="mt-3 text-2xl font-bold text-slate-900 sm:text-3xl">{featured.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{featured.excerpt}</p>
                <div className="mt-5 flex items-center gap-4 text-xs text-slate-500">
                  <span className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5" aria-hidden="true" /> {formatDate(featured.date)}</span>
                  <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" aria-hidden="true" /> {featured.readTime} de leitura</span>
                </div>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-cyan-600">
                  Ler artigo completo
                  <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </span>
              </div>
            </Link>
          ) : null}

          <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {rest.map(post => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="group flex flex-col overflow-hidden rounded-2xl border border-slate-100 shadow-sm transition-shadow hover:shadow-lg"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <span className="text-xs font-semibold uppercase tracking-widest text-cyan-600">{post.category}</span>
                  <h3 className="mt-3 text-base font-semibold text-slate-900">{post.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{post.excerpt}</p>
                  <div className="mt-4 flex items-center gap-3 text-xs text-slate-500">
                    <span className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5" aria-hidden="true" /> {formatDate(post.date)}</span>
                    <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" aria-hidden="true" /> {post.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </section>

      <section className="bg-slate-900 py-16 sm:py-20">
        <Container className="flex flex-col items-center gap-6 text-center">
          <div>
            <h2 className="text-2xl font-bold text-white sm:text-3xl">Receba nossas novidades</h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-slate-300">
              Conteúdos exclusivos sobre segurança eletrônica e conectividade corporativa, direto no seu e-mail.
            </p>
          </div>
          <NewsletterForm />
        </Container>
      </section>
    </Layout>
  )
}

export default Blog
